<template>
    <el-dialog :title="evaluateInfo ? '吊顶服务评价' : '吊顶服务工单'" :visible="visibleOrder" width="50%" @close="closeDialog"
        :close-on-click-modal="false" append-to-body>
        <div class="container">
            <div class="dynamic-cards" v-if="customsData">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>费用清单:</span>
                    </div>
                    <el-table :data="customsData.info" style="width: 100%" border>
                        <el-table-column prop="name" label="项目"></el-table-column>
                        <el-table-column prop="value" label="数量"></el-table-column>
                        <el-table-column prop="customerPrice" label="客户单价"></el-table-column>
                        <el-table-column prop="customerTotalPrice" label="客户总价"></el-table-column>
                    </el-table>
                    <el-row>
                        <el-col :span="24">
                            <p>客户总价: {{ customsData.customerTotalPrice }}</p>
                        </el-col>
                    </el-row>
                    <el-table :data="customsData.info" style="width: 100%" border>
                        <el-table-column prop="name" label="项目"></el-table-column>
                        <el-table-column prop="value" label="数量"></el-table-column>
                        <el-table-column v-if="customsData.decorationCompany == 'YES'" prop="decorationCompanyPrice"
                            label="装饰公司单价"></el-table-column>
                        <el-table-column v-else prop="merchantPrice" label="商家单价"></el-table-column>
                        <el-table-column v-if="customsData.decorationCompany == 'YES'"
                            prop="decorationTotalCompanyPrice" label="装饰公司总价"></el-table-column>
                        <el-table-column v-else prop="merchantTotalPrice" label="商家总价"></el-table-column>
                    </el-table>
                    <el-row>
                        <el-col v-if="customsData.decorationCompany == 'YES'" :span="24">
                            <p>装饰公司总价：{{ customsData.decorationCompanyTotalPrice }}</p>
                        </el-col>
                        <el-col v-else :span="24">
                            <p>商家总价：{{ customsData.merchantTotalPrice }}</p>
                        </el-col>
                    </el-row>
                </el-card>
            </div>
            <div class="fixed-cards">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>服务工单详情:</span>
                    </div>
                    <div class="card-content">
                        <el-row v-if="dynamicColumns.length > 0">
                            <el-col v-for="column in dynamicColumns" :key="column.id"
                                style="display: flex;align-items: center;text-align: center;"
                                :span="getSpan(dynamicColumns.length)">
                                <strong>{{ column.fieldName }}:</strong>
                                <span v-if="['input', 'checkbox', 'radio'].includes(column.inputType)">{{
        column.fieldValue }}</span>
                                <!-- 评分星级 -->
                                <span v-else-if="column.inputType === 'star'"
                                    style="display: flex;align-items: center;text-align: center;">
                                    <el-rate v-model="column.fieldValue" disabled></el-rate>
                                    <span>{{ column.fieldValue == '1' ? '差' : column.fieldValue == '2' ? '一般' :
        column.fieldValue == '3' ? '好' : column.fieldValue == '4' ? '很好' :
            column.fieldValue
                == '5' ? '非常好' : '' }}</span>
                                </span>
                                <span v-else><time>{{ column.fieldValue }}</time></span>
                            </el-col>
                        </el-row>
                        <el-row v-if="dynamicColumns.length === 0">
                            <el-col :span="24">
                                <p>暂无数据</p>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </div>
            <div class="dynamic-cards" v-if="imageFields.length > 0">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>工单清单图片信息:</span>
                    </div>
                    <div class="form-row" v-for="column in imageFields" :key="column.id">
                        <p class="gap-line-border" v-if="column.inputType === 'img'">
                            <span class="nameStyle">{{ column.fieldName }}:</span>
                            <span class="gap-line"></span>
                            <span v-if="column.fieldValue">
                                <viewer :images="formmaterImage(column.fieldValue)">
                                    <img v-for="src in formmaterImage(column.fieldValue)" :src="src" :key="src"
                                        class="card-image" />
                                </viewer>
                            </span>
                            <span v-else>暂无图片</span>
                        </p>
                    </div>
                </el-card>
            </div>
            <div class="dynamic-cards" v-if="historyReasons">
                <el-card shadow="hover" class="card">
                    <div slot="header" class="clearfix">
                        <span>历史退回原因:</span>
                    </div>
                    <div class="form-row" v-for="(remark, index) in historyReasons.split(',')" :key="index">
                        <p class="gap-line-border">
                            <span> <span class="nameStyle">第{{ index + 1 }}次退回原因:</span>{{ remark }}</span>
                            <span class="gap-line"></span>
                        </p>
                    </div>
                </el-card>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="text" icon="el-icon-check" size="small" plain v-if="info.status == 'TO_BE_THE_FINAL'"
                @click.stop="pass()">通过</el-button>
            <el-button type="text" icon="el-icon-close" size="small" plain v-if="info.status == 'TO_BE_THE_FINAL'"
                @click.stop="refuse()">拒绝</el-button>
            <el-button v-if="info.status != 'TO_BE_THE_FINAL'" type="text" size="small" icon="el-icon-close" plain
                @click="closeDialog">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { evaluateInfoView } from "@/api/salesCloud/preFilter";
import { findDataSourceFields } from "@/api/work/dynamicForm";
import { passOrRefused,findCustomsDeclaration } from "@/api/work/ceiling/merchants";
import { getEliveryOrder } from "@/api/work/eliveryOrder";
import { DIC } from "@/const/dic";
// import { formatterTime } from "@/util/util";
export default {
    name: "ViewServiceDiary",
    props: {
        visibleOrder: {
            type: Boolean,
            required: true,
        },
        orderId: {
            type: [String, Number],
            required: true,
        },
        evaluateInfo: {
            type: Boolean,
            default: false,
        },
        id: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            tableData: [], // 存放固定字段数据
            dynamicColumns: [], // 存放动态字段列数据
            imageFields: [], // 存放动态图片字段数据
            inputTypes: [], // 获取动态控件类型
            type: '',
            info: {},
            historyReasons: '',
            customsData: null, // 存放费用清单数据
        };
    },
    created() {
        // 初始加载时如果 orderId 已经有值，调用 handleList
        if (this.orderId) {
            // 获取动态控件类型
            findDataSourceFields().then(res => {
                let data = JSON.parse(res.data);
                this.inputTypes = data;

                // 获取产品数据
                const orderId = this.orderId; // 假设产品ID通过路由参数传递
                if (orderId) {
                    this.fetchGoodsData(orderId);
                }
            }).catch(err => {
                this.$message.error('获取动态控件类型失败', err);
            });
        }
    },
    watch: {
        /**
         * 
         * @param newVal 
         * @description 监听 visibleOrder 的变化
         * @returns void
         */
        visibleOrder(newVal) {
            if (newVal && this.orderId) {
                // 获取动态控件类型
                findDataSourceFields().then(res => {
                    let data = JSON.parse(res.data);
                    this.inputTypes = data;

                    // 获取产品数据
                    const orderId = this.orderId; // 假设产品ID通过路由参数传递
                    if (orderId) {
                        this.fetchGoodsData(orderId);
                        this.findCustomsDeclaration();
                    }
                }).catch(err => {
                    this.$message.error('获取动态控件类型失败', err);
                });
            }
        }
    },
    methods: {
        pass() {
            this.$confirm("确认通过？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let data = { ...this.info }
                    data.status = 'TO_BE_ACCEPTED';
                    passOrRefused(data).then((res) => {
                        if (res.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            this.closeDialog();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => { });
        },
        refuse() {
            this.$prompt("请输入拒绝原因", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /^.{1,255}$/,
                inputErrorMessage: "请输入正确长度的拒绝原因1-255",
            })
                .then(({ value }) => {
                    let data = { ...this.info }
                    data.status = 'WAIT_INSTALL';
                    data.reason = this.historyReasons ? this.historyReasons + ',' + value : value;
                    passOrRefused(data).then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            this.closeDialog();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        message: "提交出错",
                        type: "error",
                    });
                });
        },
        findCustomsDeclaration() {
            findCustomsDeclaration(this.id).then(res => {
                if (res.code === "200") {
                    this.customsData = JSON.parse(res.data);
                    console.log('this.customsData::: ', this.customsData);

                } else {
                    this.$message.error(res.message);
                }
            });
        },
        /**
         * 
         * @param orderId 工单ID
         * @description 获取工单数据
         * @returns void
         */
        fetchGoodsData(orderId) {
            const params = {
                id: orderId,
                code: this.evaluateInfo ? 'AFTER_SALES_EVALUATION' : 'WORK_HANG_CEILING'
            };
            getEliveryOrder(this.orderId).then(res => {
                if (res.code === "200") {
                    const data = JSON.parse(res.data).rows[0];
                    this.info = data;
                    if (data.reason) {
                        this.historyReasons = data.reason;
                    }
                    console.log(this.info);
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            });
            // 获取产品数据
            evaluateInfoView(params).then(res => {
                if (res.code == "200") {
                    const jsonData = JSON.parse(res.data); // 解析返回的 JSON 数据
                    // 将图片字段单独处理
                    const imageFields = jsonData.list.filter(item => item.inputType == '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType), // 获取输入类型
                        fieldValue: item.value
                    }));
                    this.imageFields = imageFields;
                    // 其他字段
                    const dynamicColumns = jsonData.list.filter(item => item.inputType != '8').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType), // 获取输入类型
                        fieldValue: item.dataType.word == 'star' ? parseInt(item.value) : item.value
                    }));
                    this.dynamicColumns = dynamicColumns;
                    console.log('this.dynamicColumns:::1 ', this.dynamicColumns);

                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            }).catch(err => {
                this.$message.error('获取数据失败', err);
            });
        },
        /**
         * 
         * @param length 
         * @description 动态计算每列的span值
         * @returns number
         */
        getSpan(length) {
            // 动态计算每列的span值
            return Math.floor(24 / Math.min(length, 3)); // 最多3列
        },
        /**
         * 
         * @param row 
         * @description 格式化图片字段
         * @returns Array
         */
        formmaterImage(row) {
            let str = new Array();
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        /**
         * 
         * @param inputType 
         * @description 获取输入类型的名称
         * @returns string
         */
        getInputType(inputType) {
            const item = this.inputTypes.find(type => type.id == inputType);
            return item ? item.word : ''; // 返回输入类型的名称
        },
        /**
         * 
         * @param status 
         * @description 获取状态的名称
         * @returns string
         */
        getStatusLabel(status) {
            const statusItem = DIC.PRE_FILTER_STATUS.find(item => item.value === status);
            return statusItem ? statusItem.label : status;
        },
        /**
         * 
         * @description 关闭弹窗
         * @returns void
         */
        closeDialog() {
            this.$emit("update:visibleOrder", false);
        }
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    min-height: 80%;
    box-sizing: border-box;
    font-family: fangsong;
    font-size: large;
}

.fixed-cards,
.dynamic-cards {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.clearfix {
    font-weight: bold;
}

.gap-line-border {
    padding: 0 10px;
    border: 1px dashed #ccc;
}

.gap-line {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #ccc;
    margin-top: 10px;
}

.nameStyle {
    font-weight: bold;
    line-height: 4px;
}

.card {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
}

.card:hover {
    transform: scale(1.01);
}

.dynamic-cards:last-child {
    margin-bottom: 30px;
}

.card-content {
    padding: 20px;
    font-family: fangsong;
    word-break: break-word;
    /* 自动换行 */
}

.card p {
    margin: 10px 0;
    line-height: 1.6;
    word-break: break-word;
    /* 自动换行 */
}

.card strong {
    color: #333;
}

.card .el-image {
    border-radius: 5px;
}

.card-image {
    width: 100px;
    height: 100px;
    margin: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
    cursor: pointer;
    transition: transform 0.3s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}

.form-row p {
    flex: 1;
    min-width: calc(20% - 10px);
    /* 每行三个内容，减去间隙 */
    box-sizing: border-box;
    margin: 0;
}

.dynamic-cards .card {
    width: 100%;
}

@media (max-width: 768px) {
    .card {
        width: 100%;
    }

    .form-row {
        flex-direction: column;
    }

    .form-row p {
        min-width: 100%;
        /* 小屏幕下每行一个内容 */
    }
}
</style>